import Auth, { AuthActionsContainer } from "./index";
import { Alert, Box, FormHelperText, Grid, Typography } from "@mui/material";
import StyledTextField from "../../new_components/styled-text-field";
import OrangeArrowButton from "../../new_components/buttons/orange-arrow-button";
import ReCAPTCHA from "react-google-recaptcha";
import { useCallback, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import { NavLink } from "react-router-dom";
import useAuth from "../../auth/useAuth";

const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email address").required("Email is required"),
    recaptcha: Yup.string()
        .required("ReCaptcha is required"),
});

const ForgotPassword = () => {
    const [success, setSuccess] = useState(false);
    const [erCaptcha, setErCaptcha] = useState(false);
    const reCaptchaRef = useRef();
    const auth = useAuth();

    const source = axios.CancelToken.source();

    const handleSubmit = async (email) => {
        try {
            await auth.forgotPassword(email);
            setSuccess(true);
        } catch (error) {
            formik.setErrors({ submit: "Something went wrong" });
        }
    };

    const formik = useFormik({
        initialValues: {
            email: "",
            recaptcha: ""
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            handleSubmit(values.email);
        },
    });

    useEffect(() => {
        return () => {
            source.cancel();
        };
    }, [source]);

    const handleCaptchaChange = useCallback((value) => {
        formik.setFieldValue("recaptcha", value);
        setErCaptcha(!value);
    }, []);

    return (
        <Auth>
            <Grid container flexDirection="column" gap={1}>
                { success
                    ? <div className="success__message">
                        <p>
                            Check your email inbox <NavLink to="/sign-in">Sign In</NavLink>
                            <br/>
                            <small>
                                Please allow up to 5 minutes for the email to come through before attempting to
                                reset your password
                                again.
                            </small>
                        </p>
                    </div>
                    : <>
                        <Grid item display="flex" gap={1.5} flexDirection="column" alignItems="center">
                            <Typography variant="authTitle">Forgot Password</Typography>
                        </Grid>
                        <Box component="form" noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
                    <Grid item display="flex" gap={1} flexDirection="column">
                        <StyledTextField
                            required
                            label="Email"
                            variant="filled"
                            fullWidth
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />
                    </Grid>
                    {formik.errors.submit && <Box item display="flex" justifyContent="center" marginTop={2}>
                        <Alert severity="error">{formik.errors.submit}</Alert>
                    </Box>}
                    <AuthActionsContainer>
                        <div
                            className="form-group"
                            style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}
                        >
                            <ReCAPTCHA
                                ref={reCaptchaRef}
                                sitekey="6Lfk6tQpAAAAANeQHyiiY7FOZj7Xf-ZosDzq2eAL"
                                onChange={handleCaptchaChange}
                            />
                            {formik.touched.recaptcha && formik.errors.recaptcha && (
                                <FormHelperText error={formik.touched.recaptcha && Boolean(formik.errors.recaptcha)}>
                                    {formik.errors.recaptcha}
                                </FormHelperText>
                            )}
                            {erCaptcha && <FormHelperText error={erCaptcha}>ReCaptcha error</FormHelperText>}
                        </div>
                        <OrangeArrowButton type="submit" alignSelf="end" style={{ marginLeft: "20px" }}>
                            Reset Password
                        </OrangeArrowButton>
                    </AuthActionsContainer>
                </Box>
                    </>
                }
            </Grid>
        </Auth>
    );
};

export default ForgotPassword;